import { ErrorMappingValueType } from 'typings';

type SignInErrorMappingKeyType = 'INVALID_CREDENTIALS' | string;
type PasswordResetCheckErrorMappingKeyType = 'INVALID_TOKEN' | string;
type PasswordForgotErrorMappingKeyType = 'NOT_FOUND' | string;
type PasswordResetFinishErrorMappingKeyType = 'PASSWORD_DID_NOT_MATCH' | 'INVALID_TOKEN' | 'ok' | string;

type SignInErrorMappingType = {
  [key: SignInErrorMappingKeyType]: ErrorMappingValueType;
};
export const SignInErrorMapping: SignInErrorMappingType = {
  INVALID_CREDENTIALS: {
    type: 'error',
    message: 'Email or password is invalid!',
  },
};

type PasswordForgotErrorMappingType = {
  [key: PasswordForgotErrorMappingKeyType]: ErrorMappingValueType;
};
export const PasswordForgotMapping: PasswordForgotErrorMappingType = {
  NOT_FOUND: {
    type: 'error',
    message: 'Email not found',
  },
};

type PasswordResetCheckErrorMappingType = {
  [key: PasswordResetCheckErrorMappingKeyType]: ErrorMappingValueType;
};
export const PasswordResetCheckMapping: PasswordResetCheckErrorMappingType = {
  INVALID_TOKEN: {
    type: 'error',
    message: 'Invalid token!',
  },
};

type PasswordResetFinishErrorMappingType = {
  [key: PasswordResetFinishErrorMappingKeyType]: ErrorMappingValueType;
};
export const PasswordResetFinishMapping: PasswordResetFinishErrorMappingType = {
  INVALID_TOKEN: {
    type: 'error',
    message: 'Invalid token!',
  },
  PASSWORD_DID_NOT_MATCH: {
    type: 'error',
    message: 'Password did not match!',
  },
};
